import { memo } from 'react';
import dayjs from 'dayjs';

import { HeaderType } from '@utils/types';
import { getPolicyType } from '@lib/enum';
import { Policy } from '@graphql/types';

import { TableRow, TableCell } from '@components/share/Table/table.style';

type PolicyTableRowType = {
    header: HeaderType[];
    data: Policy;
};

const PolicyTableRow = ({ header = [], data }: PolicyTableRowType) => {
    return (
        <TableRow $default>
            <TableCell $minWidth={header[0].minWidth} $width={header[0].width}>
                {data?.createdAt
                    ? dayjs(data.createdAt).format('YYYY-MM-DD HH:mm')
                    : '-'}
            </TableCell>
            <TableCell $minWidth={header[1].minWidth} $width={header[1].width}>
                {data?.type ? getPolicyType(data?.type as number) : '-'}
            </TableCell>
            <TableCell $minWidth={header[2].minWidth} $width={header[2].width}>
                {data?.title || '-'}
            </TableCell>
            <TableCell $minWidth={header[3].minWidth} $width={header[3].width}>
                {data?.creatorName
                    ? `${data?.creatorName} ${data?.creatorRank}`
                    : '-'}
            </TableCell>
        </TableRow>
    );
};

export default memo(PolicyTableRow);
